import { render, staticRenderFns } from "./index2024.vue?vue&type=template&id=9763ece0&scoped=true"
import script from "./index2024.vue?vue&type=script&lang=js"
export * from "./index2024.vue?vue&type=script&lang=js"
import style0 from "./index2024.vue?vue&type=style&index=0&id=9763ece0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9763ece0",
  null
  
)

export default component.exports